module.exports = __webpack_public_path__ + "img/avatar-0.52d66cf5.png";